import React from 'react'

const SidebarNavItem = ({
  icon,
  label,
  tabName,
  activeTab,
  onTabClick,
  isMobile,
}) => {
  const isActive = activeTab === tabName

  const baseClasses =
    'cursor-pointer transition-all text-[15px] duration-200 flex items-center gap-3'
  const mobileClasses = `mb-2 mx-3 px-6 py-3 rounded-xl font-medium relative ${
    isActive
      ? 'bg-red-50 text-red-600 font-semibold'
      : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'
  }`
  const desktopClasses = `p-3 rounded-lg relative ${
    isActive
      ? 'bg-red-50 text-citrus-red'
      : 'text-slate-600 hover:bg-slate-50 hover:text-red-600'
  }`

  return (
    <div
      className={`${baseClasses} ${isMobile ? mobileClasses : desktopClasses}`}
      onClick={() => onTabClick(tabName)}
    >
      <i className={`${icon} w-5 text-center`}></i>
      {label}
    </div>
  )
}

export default SidebarNavItem
